import { render } from "./ModalComp.vue?vue&type=template&id=d60f6c78&scoped=true"
import script from "./ModalComp.vue?vue&type=script&lang=js"
export * from "./ModalComp.vue?vue&type=script&lang=js"

import "./ModalComp.vue?vue&type=style&index=0&id=d60f6c78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d60f6c78"]])

export default __exports__